import type {CatalogMenuGroup} from '@/types/View'

// Хардкод L2-меню. Не зависит от записей в коллекции `views` MongoDB.
// Используется в VAsideMenu, рендерится отдельным блоком после catalogmenu из БД.
// Видимость контролируется по permission/role — см. @/composables/useL2Identity.
export const L2_MENU_GROUP: CatalogMenuGroup = {
  type: 'group',
  icon: 'user',
  labelRu: 'Поддержка L2',
  labelKk: 'L2 қолдауы',
  items: [
    {
      route: 'l2/organizations',
      labelRu: 'Организации',
      labelKk: 'Ұйымдар',
    },
    {
      route: 'l2/address-search',
      labelRu: 'Поиск адресов',
      labelKk: 'Мекенжайлар',
    },
  ],
}
